
import { Vue, Options } from 'vue-class-component'
let instanceCounter = 0
@Options({ name: 'KeyMinus', props: { width: { type: [Number, String], default: 56 }, height: { type: [Number, String], default: 40 } } })
export default class KeyMinus extends Vue {
  private instanceId = `keyMinus-${++instanceCounter}`
  get glossId(): string { return `${this.instanceId}-gloss` }
  get highlightId(): string { return `${this.instanceId}-highlight` }
}
